import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'vx-ui-components';
import { Flex, Box } from 'reflexbox';
import Growler from '../../containers/Notification';
import { spinner } from 'vx-commons/lib/utils/icons';
import styles from './styles.css';
import {
  selectError,
} from 'vx-commons/lib/selectors';

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&"); // eslint-disable-line
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

class PasswordRecovery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.formDefaults,
      password: "",
      confirmPassword: "",
      submitted: false,
      passwordError: false,
    };
  }

  handlePasswordRecovery = (e) => {
    const {
      password,
      confirmPassword,
    } = this.state;
    e.preventDefault();

    const recovery_code = getParameterByName("recovery_code");
    
    if(password === confirmPassword){
      this.props.submitPasswordRecovery(password, recovery_code);
      this.setState({ submitted: true });
      return;
    }

    this.setState({ passwordError: true });
  }

  handlePasswordChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  checkIfEmpty = () => {
    const {
      password,
      confirmPassword,
    } = this.state;

    if(password === "" || confirmPassword === ""){
      this.setState({ passwordError: false });
    }   
  };

  render() {
    const { password, confirmPassword, submitted, passwordError} = this.state;
    const { loginRequired, error} = this.props;


    if(loginRequired && submitted && !error) {
      return spinner();
    }

    return (
      <Flex align="center" className={styles.loginWrap}>
        <Growler />
        <Box className={styles.login}>
          <form onSubmit={this.handlePasswordRecovery} style={{ width: '100%' }}>
            <div className={styles.wrap}>
              <label className={styles.label}>Please, insert new password:</label>
              <input
                className={styles.input}
                type="password"
                name="password"
                required
                value={password}
                onChange={this.handlePasswordChange}
                onBlur={this.checkIfEmpty}
                autoFocus
              />
            </div>
            <div className={styles.wrap}>
              <label className={styles.label}>Confirm new password:</label>
              <input
                className={styles.input}
                type="password"
                name="confirmPassword"
                required
                value={confirmPassword}
                onBlur={this.checkIfEmpty}
                onChange={this.handlePasswordChange}
                autoFocus
              />
            </div>

            { passwordError && (
              <div className={styles.wrap} style={{ color: 'red', textAlign: "center" }}>
                Entered passwords do not match or are empty.
              </div>
              )
            }

            <div style={{ padding: '2em' }}>
              <Button
                label="reset"
                type="submit"
                style={{ width: '100px',display: 'block', margin: '0 auto' }}
              />
            </div>
          </form>
        </Box>
      </Flex>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  error: selectError(),
});

PasswordRecovery.propTypes = {
  submitPasswordRecovery: PropTypes.func,
};

export default connect(
  mapStateToProps
)(PasswordRecovery);




// WEBPACK FOOTER //
// ./src/containers/PasswordRecovery/index.js